import React, { useState } from "react";
import properties from '../../config/environmentProperties';
import { Card } from "primereact/card";
import { Button } from 'primereact/button';
import { utitService } from '../../services/util';
import { Dialog } from 'primereact/dialog';
import { Carousel } from 'primereact/carousel';

const TeamTrainingUserDetailsView = ({ clickedRowData }) => {
  console.log(clickedRowData, "TeamTrainingUserDetailsView")
  const docPath = properties.currentEnvironment.docPath + 'training-documents/';
  const [certificateVisible, setCertificateVisible] = useState(false);

  /* Uploaded Document View on Popup */

  const certificatePopup = () => {
    return (
      <Dialog header={'Documents'} visible={certificateVisible} modal style={{ width: '1200px', height: '900px' }} onHide={() => setCertificateVisible(false)}>
        {renderCertificateContent(clickedRowData)}
      </Dialog>
    )
  }

  const renderCertificateContent = (rowData) => {
    return (
      <Carousel
        value={rowData?.trainingDocuments}
        itemTemplate={yourCarouselItemTemplate}
        numVisible={1}
        numScroll={1}
        circular
      />
    );
  };

  const yourCarouselItemTemplate = (doc) => {
    return (
      <>
        <p>{doc.fileName}</p>
        <iframe src={docPath + doc.fileName} title={`Document ${doc.fileName}`} style={{ width: '100%', height: '900px' }} />
      </>
    )
  };
  /* Uploaded Document View on Popup */

  const trainingStatusTemp = (rowData) => {
    if (rowData?.trainingDetailStatus === 1) {
      return <span>In Progress</span>;
    }
    if (rowData?.trainingDetailStatus === 2 && (
      // Case 1: Instructor-Led training with everything completed
      (rowData?.trainingType === 'Instructor-Led' &&
        !rowData?.is_assessment && !rowData?.is_feedback
      ) ||

      // Case 2: Non-Instructor-Led with specific criteria
      (rowData?.trainingType === 'Self-Paced' &&
        !rowData?.is_assessment && !rowData?.is_feedback
      )
    )
    ) {
      return <span>Attended</span>;
    }
    if (rowData?.trainingDetailStatus === 2 && (
      // Case 1: Instructor-Led training with everything completed
      (rowData?.trainingType === 'Instructor-Led' &&
        rowData?.is_assessment &&
        rowData?.is_feedback &&
        !rowData?.is_assesment_completed &&
        !rowData?.is_feedback_completed
      )
    )
    ) {
      return <span>Assessment Pending</span>;
    }
    if (rowData?.trainingDetailStatus === 2 && (
      // Case 1: Instructor-Led training with everything completed
      (rowData?.trainingType === 'Instructor-Led' &&
        rowData?.is_assessment &&
        rowData?.is_feedback &&
        rowData?.is_assesment_completed &&
        !rowData?.is_feedback_completed
      ) ||
      // Case 2: Non-Instructor-Led with specific criteria
      (rowData?.trainingType === 'Self-Paced' &&
        !rowData?.is_assessment &&
        rowData?.is_feedback &&
        !rowData?.is_assesment_completed &&
        !rowData?.is_feedback_completed
      )
    )
    ) {
      return <span>Feedback Pending</span>;
    }
    if (rowData?.trainingDetailStatus === 2 && (
      // Case 1: Instructor-Led training with everything completed
      (rowData?.trainingType === 'Instructor-Led' &&
        rowData?.is_assessment &&
        rowData?.is_feedback &&
        rowData?.is_assesment_completed &&
        rowData?.is_feedback_completed
      ) ||
      // Case 2: Non-Instructor-Led with specific criteria
      (rowData?.trainingType === 'Self-Paced' &&
        !rowData?.is_assessment &&
        rowData?.is_feedback &&
        !rowData?.is_assesment_completed &&
        rowData?.is_feedback_completed
      )
    )
    ) {
      return <span>Completed</span>;
    }
    // Fallback
    return <span>TODO</span>;
  };

  return (
    <>
      <hr />
      <div className="row mp-panel">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Project Name :</div>
            <div className='col'>
              {clickedRowData?.projectName ? clickedRowData?.projectName : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Target Skill :</div>
            <div className='col'>
              {clickedRowData?.targetSkills ? clickedRowData?.targetSkills?.title : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Category Of Training :</div>
            <div className='col'>
              {clickedRowData?.categoryOfTrainings ? clickedRowData?.categoryOfTrainings?.title : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Type :</div>
            <div className='col'>
              {clickedRowData?.trainingType ? clickedRowData?.trainingType : '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Progress Status :</div>
            <div className='col'>
              {/* {clickedRowData?.trainingDetails[0] ? utitService.getUserTrainingStatus(clickedRowData?.trainingDetails[0]?.trainingDetailStatus) : '-'} */}
              {/* {clickedRowData?.trainingDetailStatus === 1 ? 'In Progress' : clickedRowData?.trainingDetailStatus === 2 && !clickedRowData?.is_assessment && !clickedRowData?.is_feedback ? 'Attended' : clickedRowData?.trainingDetailStatus === 2 && clickedRowData?.is_assessment && clickedRowData?.is_feedback && !clickedRowData?.is_assesment_completed && !clickedRowData?.is_feedback_completed ? 'Assesment Pending' : clickedRowData?.trainingDetailStatus === 2 && clickedRowData?.is_assessment && clickedRowData?.is_feedback && clickedRowData?.is_assesment_completed && !clickedRowData?.is_feedback_completed ? 'Feedback Pending' : clickedRowData?.trainingDetailStatus === 2 && clickedRowData?.is_assessment && clickedRowData?.is_feedback && clickedRowData?.is_assesment_completed && clickedRowData?.is_feedback_completed ? 'Completed' : 'TODO'} */}
              {trainingStatusTemp(clickedRowData)}
            </div>
          </div>

          {/* <div className="col-3">
            <div className='col trf-Detail-Label'>Training Progress(In Percentage) :</div>
            <div className='col'>
              {clickedRowData?.percentage ? clickedRowData?.percentage : 'Not Updated Yet'}
            </div>
          </div> */}
          <div className="col-3">
            <div className='col trf-Detail-Label'>Feedback Score :</div>
            <div className='col'>
              {clickedRowData?.feedback_score ? clickedRowData?.feedback_score : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Assesment Score :</div>
            <div className='col'>
              {clickedRowData?.assesment_score ? clickedRowData?.assesment_score : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>View Certificate : </div>
            <div className='col'>
              <Button title="View" icon="pi pi-eye" className="p-button-rounded p-button-text" severity="secondary" onClick={() => setCertificateVisible(true)} disabled={clickedRowData?.trainingDocuments?.length > 0 ? false : true} />
              {/* <Button onClick={() => setCertificateVisible(true)} label="View" disabled={clickedRowData?.trainingDocuments?.length > 0 ? false : true} /> */}
            </div>
          </div>
        </div>
      </div>


      {/* <div className="row">
        <div className="grid">
        <div className="col-3">
            <div className='col trf-Detail-Label'>View Certificate :</div>
            <div className='col'>
              <Button onClick={() => setCertificateVisible(true)} label="View" disabled={clickedRowData?.trainingDocuments?.length > 0 ? false : true} />
            </div>
          </div>
        </div>
      </div> */}

      <div className="row">
        <div className="grid">
          <div className="mp-panel col-9">
            <div className='col trf-Detail-Label'>Expected Business Outcome :</div>
            {clickedRowData?.businessoutcomeDetails?.map((item, index) => (
              <div className='col mr-2 bordered mt-1'>
                {item.title}
              </div>
            ))}
          </div>
          <div className="mp-panel col-3">
            <div className='col trf-Detail-Label'>Completed Course Duration :</div>
              <div className='col'>
                {clickedRowData?.completedCourseHours ? clickedRowData?.completedCourseHours : '00'}
                {":"}
                {clickedRowData?.completedCourseMinutes ? clickedRowData?.completedCourseMinutes : '00'}
              </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Progress Update :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>
                {clickedRowData?.progressUpdate ? clickedRowData?.progressUpdate : 'Not Updated Yet'}
              </Card>
            </div>
          </div>
          <div className="col-6">
            <div className='col trf-Detail-Label'>Training Learnings :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>
                {clickedRowData?.trainingLearning ? clickedRowData?.trainingLearning : 'Not Updated Yet'}
              </Card>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Learning Apply on Project :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>
                {clickedRowData?.learningApplyOnProject ? clickedRowData?.learningApplyOnProject : 'Not Updated Yet'}
              </Card>
            </div>
          </div>
        </div>
      </div>
      {certificatePopup()}
    </>
  )
}
export default TeamTrainingUserDetailsView;
